<template>
    <div class="service m-b-10">
      <p class="brder-b title">补贴套餐</p>
      <ul class="serviceUl flex-row-wrap">
        <li class="item" v-for="(item, index) in list" :key="index" @click="viewPage(item.type)">
            <img :src="item.img" alt="">
            <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
</template>
<script>
import contract from '@/assets/img/合同@3x.png';
import appointment from '@/assets/img/leijiyuyue@3x.png';
import budget from '@/assets/img/yusuan@3x.png';
import news from '@/assets/img/xiaoxi-2@3x.png';
import problem from '@/assets/img/ICon--2@3x.png';
import follow from '@/assets/img/guanzhu-3@3x.png';
import receipt from '@/assets/img/sj.png';
import service from '@/assets/img/评价.png';
export default {
    data(){
        return {
            contract,
            appointment,
            budget,
            news,
            problem,
            follow,
            receipt,
            list:[
                {name: '补贴套餐付款', img: news, type: 1 },
                {name:'补贴套餐电子收据', img: receipt , type: 2},
                // {name:'我的预算', img:budget, type: 1},
                // {name:'我的消息', img:news},
                // {name:'退出登录', img:appointment, type:3},
                // {name: '我的收据', img: receipt, type: 5},
                // {name: '我的服务单', img: service, type: 6},
            ]
        }
    },
    methods:{
      viewPage(type){
        if(type == 1){
          this.$router.push({path:'/packagesList'})
        } else if (type == 2) {
          this.$router.push({path:'/packagesComplete'});
        } else if (type == 3) {
          this.$loca.removeItem('name');
          this.$loca.removeItem('phone');
          this.$router.push({path:'/login'});
        } else if (type == 5) {
          this.$router.push({path:'/receipt'});
        }else if(type == 6){
          this.$router.push({path:'/service',query:{ status: 1 }});
        }
      }
    }
}
</script>
<style lang="scss" scoped>
  .service{
    padding-bottom: 20px;
    background: $ffff;
    .title{
      height: 62px;
      font-size:30px;
      color:$color-51;
      line-height:70px;
      margin: 0 20px;
      padding-left: 16px;
      font-weight: bold;
      &::before{
        content: '';
        width:4px;
        height:20px;
        display: inline-block;
        margin-right: 17px;
        background:$color-176;
      }
    }
    .serviceUl{
        margin:  7px 33px 5px 33px;
        align-items: flex-end;
        .item{
            text-align: center;
            margin-top: 20px;
            margin-right: 40px;
            p{
                margin-top: 15px;
                font-size:22px;
                color: $color-85;
            }
            img{
                width: 51px;
                height: auto;
            }
        }
    }
  }
</style>


